import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import branding from "@/config/branding";

// Convert hex color to HSL components string (e.g., "217 100% 34%")
function hexToHSL(hex) {
  hex = hex.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16) / 255;
  const g = parseInt(hex.substring(2, 4), 16) / 255;
  const b = parseInt(hex.substring(4, 6), 16) / 255;

  const max = Math.max(r, g, b);
  const min = Math.min(r, g, b);
  let h, s, l = (max + min) / 2;

  if (max === min) {
    h = s = 0;
  } else {
    const d = max - min;
    s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
    switch (max) {
      case r: h = ((g - b) / d + (g < b ? 6 : 0)) / 6; break;
      case g: h = ((b - r) / d + 2) / 6; break;
      case b: h = ((r - g) / d + 4) / 6; break;
      default: h = 0;
    }
  }

  return `${Math.round(h * 360)} ${Math.round(s * 100)}% ${Math.round(l * 100)}%`;
}

// Set CSS custom properties for brand colors
const root = document.documentElement;
root.style.setProperty('--brand', hexToHSL(branding.primaryColor));
root.style.setProperty('--brand-hover', hexToHSL(branding.primaryHover));

const rootEl = ReactDOM.createRoot(document.getElementById("root"));
rootEl.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
